<form #formEndereco="ngForm">
    <div class="row">
        <h2>Endereço Residencial - Avalista</h2>
        <app-endereco icon="residencial" label="CEP" name="enderecoResidencial" [(ngModel)]="fichaCadastro._avalista.enderecos" ngDefaultControl>
        </app-endereco>
    </div>
    <!-- COMERCIAL -->
    <div *ngIf="fichaCadastro._avalista?.dadoProfissional?.classeProfissional?.empresa" class="row">
        <h2>Endereço Comercial - Avalista</h2>
        <app-endereco icon="icon zip-code" label="CEP" name="enderecoComercial" [(ngModel)]="fichaCadastro._avalista.dadoProfissional.empresa.endereco" ngDefaultControl>
        </app-endereco>
    </div>
    <!-- SELECIONAR ENDEREÇO PARA CORRESPONDÊNCIA -->
    <div class="row">
        <div class="form-group">
            <span class="icon email"></span>
            <div class="inputs">
                <label for="user-mail-address">Endereço para correspondência</label>
                <select name="user-mail-address" id="user-mail-address" class="form-control" required [(ngModel)]="fichaCadastro._avalista.tipoEnderecoCorrespondencia">
                  <option value="undefined" hidden selected>Selecione</option>
                  <option value="1">Residencial</option>
                  <option *ngIf="fichaCadastro._avalista?.dadoProfissional?.classeProfissional?.empresa" value="2">Comercial</option>
                  <option value="7">Outro</option>
              </select>
            </div>
        </div>
    </div>
</form>
<form #formEnderecoOutro="ngForm">
    <!-- OUTRO -->
    <div class="row mail-address" [ngClass]="{'dn': fichaCadastro._avalista.tipoEnderecoCorrespondencia != '7'}">
        <h2>Endereço Correspondência - Avalista</h2>
        <app-endereco icon="icon zip-code" label="CEP" name="enderecoComercial" [(ngModel)]="fichaCadastro._avalista.enderecoCorrespondencia" ngDefaultControl>
        </app-endereco>
    </div>
</form>

<!-- BOTÕES -->
<div class="row">
    <div class="marginT30 form-group tab-buttons">
        <a (click)="onClickPrevious()" class="bt-back btn btn-border-orange pull-left"><em class="fa fa-arrow-left mrBt"></em> Voltar</a>
        <a class="bt-go btn btn-full-orange pull-right" [ngClass]="{'disabled': !nextAvaliable(formEndereco.valid, formEnderecoOutro.valid)}" (click)="onClickNext()">Continuar <em class="fa fa-arrow-right mlBt"></em></a>
    </div>
</div>
